export class SynchronizableTables {
    static Allocations = 'allocations';
    static Bookings = 'bookings';
    static Customers = 'customers';
    static Providers = 'providers';
    static Todos = 'todos';
    static Templates = 'templates';
}
